<template>
<div>
	<div>
		<div class="col-lg-12">
			<h2 class="page-header" v-if="!IsModal">
				<span id="page-header">{{ pageheader }}</span>
				<a href="/customers/" class="hidden-md hidden-lg"><button class="btn btn-success">Zur Liste</button></a>
			</h2>

			<div class="row">
				<h3 class="col-lg-12">Persönliche Informationen <router-link to="/customers/new" class="btn btn-primary create-new pull-right"><i class="fa fa-plus"></i></router-link></h3>
				<div class="form-horizontal" id="customer-information">

					<div class="row">
						<div class="col-md-4">
							<custom-input inline>
								<label class="col-md-12 control-label" for="firstname">Vorname <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-md-12">
									<input name="firstname" id="firstname" class="form-control" v-model="model.model.firstname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Nachname <span style="color: #f00; font-weight: 800">*</span></label>
								<div class="col-sm-12">
									<input name="lastname" id="lastname" class="form-control" v-model="model.model.lastname" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-4">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthname">Geburtsname</label>
								<div class="col-sm-12">
									<input name="birthname" id="birthname" class="form-control" v-model="model.model.birthname" required>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthplace">Geburtsort</label>
								<div class="col-sm-12">
									<input name="birthplace" id="birthplace" class="form-control" v-model="model.model.birthplace" required>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="birthday">Geburtstag</label>
								<div class="col-sm-12">
									<datepicker id="birthday" bootstrapStyling clear-button clear-button-icon="fa fa-trash" calendar-button calendar-button-icon="fa fa-calendar" name="birthday" v-model="model.model.birthday" required language="de" format="yyyy-MM-dd"></datepicker>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="denomination">Konfession</label>
								<div class="col-sm-12">
									<select name="burial_type" id="denomination" class="form-control" v-model="model.model.denomination_id">
										<option value="0">[Keine Konfession]</option>
										<option v-for="type in $store.getters.models('denominations')" :value="type.id">{{ type.name }}</option>
									</select>
								</div>
							</custom-input>
						</div>

						<div class="col-md-3">
							<custom-input inline>
								<label class="col-sm-12 control-label" for="lastname">Geschlecht</label>
								<div class="col-sm-12">
									<select name="gender" class="form-control" v-model="model.model.gender">
										<option :value="0">[Bitte wählen]</option>
										<option :value="1">männlich</option>
										<option :value="2">weiblich</option>
										<option :value="3">transgender</option>
									</select>
								</div>
							</custom-input>
						</div>
					</div>

					<div class="row">
						<div class="form-group">
							<div class="col-lg-12 text-center">
								<a href="/customers/" class="hidden-sm hidden-xs"><button class="btn btn-success">Zur Liste</button></a>
								<button v-if="validModel" class="btn btn-primary" @click="saveCustomer()">Speichern</button>
							</div>
						</div>
					</div>

					<div class="row" v-show="model.model.id > 0 && !IsModal">
						<div class="col-lg-12">
							<div class="col-lg-12">
								<ul class="nav nav-tabs responsive-tabs">
									<li class="active"><a href="#addresses">Adressen</a></li>
									<li><a href="#contacts">Kontakte</a></li>
									<li><a href="#graves">Grabstätten</a></li>
									<li><a href="#deceaseds">Verstorbene</a></li>
								</ul>

								<div class="tab-content col-lg-12">
									<div class="tab-pane active" id="addresses">
										<custom-table :cols="addresses.cols" :src-model="model.addresses" add delete edit nosort @add="addAddress" @edit="editAddress" @delete="deleteAddress"></custom-table>
									</div>

									<div class="tab-pane" id="contacts">
										<custom-table :cols="contacts.cols" :src-model="model.contacts" add delete edit nosort @add="addContact" @edit="editContact" @delete="deleteContact"></custom-table>
									</div>

									<div class="tab-pane" id="graves">
										<custom-table :cols="graves.cols" :src-model="model.graves" add delete edit nosort select="/graves/{:grave_id}" @add="addGrave" @edit="editGrave" @delete="deleteGrave" :default-sort="graveSort"></custom-table>
									</div>

									<div class="tab-pane" id="deceaseds">
										<custom-table :cols="deceaseds.cols" :src-model="model.deceaseds" add delete nosort select="/deceaseds/{:deceased_id}" @add="addDeceased" @delete="deleteDeceased"></custom-table>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- Adressen -->
		<custom-modal ref="addressModal" title="Adresse hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<address-content ref="newAddress"></address-content>
		</custom-modal>

		<custom-modal-old v-if="visibleModal === 'deleteaddresses'" title="Adresse löschen" ok-text="Löschen" cancel-text="Abbrechen" cancel-style="btn btn-primary" @ok="confirmDeleteRelation('addresses')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diese Adresse entfernen möchten?</strong>
		</custom-modal-old>




		<!-- Kontakt -->
		<custom-modal ref="contactModal" title="Kontakt hinzufügen" ok-text="Speichern" cancel-text="Abbrechen" ok-style="btn btn-primary" cancel-style="btn btn-default">
			<contact-content ref="newContact"></contact-content>
		</custom-modal>

		<custom-modal-old title="Kontakt entfernen" v-if="visibleModal === 'deletecontacts'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('contacts')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Kontakt entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Grab -->
		<custom-modal ref="graveModal" title="Grabstätte hinzufügen">
			<div class="row">
				<div class="col-lg-10">
					<custom-input title="Grab">
						<custom-table multiselect="Speichern" @multiselect="saveAllGraves" row-add @rowAdd="saveGrave" :src-model="$store.getters.models('graves')" :cols="graveCols" store="graves" search :default-sort="graveSort"></custom-table>
					</custom-input>
				</div>

				<div class="col-lg-2">
					<custom-input title="Von">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="graves.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>

					<custom-input title="Bis">
						<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="graves.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
					</custom-input>
				</div>
			</div>
		</custom-modal>

		<custom-modal ref="graveEditModal" title="Grabstätte bearbeiten" ok-text="Aktualisieren" cancel-text="Abbrechen" cancel-style="btn btn-default">
			<custom-input title="Von">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="from" v-model="graves.model.from" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>

			<custom-input title="Bis">
				<datepicker bootstrapStyling calendar-button calendar-button-icon="fa fa-calendar" name="until" v-model="graves.model.until" required language="de" format="yyyy-MM-dd"></datepicker>
			</custom-input>
		</custom-modal>

		<custom-modal-old title="Grab entfernen" v-if="visibleModal === 'deletegraves'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('graves')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie das Grab entfernen möchten?</strong>
		</custom-modal-old>

		<!-- Verstorbener -->

		<custom-modal-old title="Verstorbenen entfernen" v-if="visibleModal === 'deletedeceaseds'" ok-text="Löschen" cancel-text="Abbrechen" @ok="confirmDeleteRelation('deceaseds')" @cancel="visibleModal = ''" ok-style="btn btn-danger">
			<strong>Sind Sie sicher, dass Sie diesen Verstorbenen entfernen möchten?</strong>
		</custom-modal-old>

		<custom-modal ref="deceasedAddModal" title="Verstorbenen hinzufügen">
			<tabs>
				<tab header="Hinzufügen">
					<custom-table row-add @rowAdd="storeDeceased" :src-model="$store.getters.models('deceaseds')" :cols="deceasedCols" store="deceaseds" search :default-sort="graveSort"></custom-table>
				</tab>

<!--				<tab header="Anlegen">
					<new-deceased :is-modal="true" @save="saveDeceased" ref="deceasedContent"></new-deceased>
				</tab> -->
			</tabs>
		</custom-modal>

		<!-- Fehlermeldungen -->
		<custom-modal-old v-if="visibleModal === 'errSavingModel'" @ok="visibleModal = ''" ok-text="OK" @cancel="visibleModal = ''">
			Fehler beim Speichern des Kunden.
		</custom-modal-old>
	</div>
</div>
</template>

<script>
import moment from 'moment'

import CustomTable from 'components/custom-table.vue'
import CustomModal from 'components/custom-modal.vue'
import CustomModalOld from 'components/custom-modal-old.vue'
import CustomInput from 'components/custom-input.vue'
import CustomerDeceased from 'components/customer-deceased.vue'
import CustomSelect from 'components/custom-select.vue'
import CustomSearchInput from 'components/custom-search-input.vue'
import AddressContent from 'components/address-content.vue'
import ContactContent from 'components/contact-content.vue'
import { ModelListSelect } from 'vue-search-select'

import NewDeceased from 'views/DeceasedEdit.vue'

import Datepicker from 'vuejs-datepicker'
import { tabs, tab, tabGroup } from 'vue-strap'

import AddressesModel from 'models/addresses.js'
import ContactsModel from 'models/contacts.js'
import CustomersModel from 'models/customers.js'
import GravesModel from 'models/graves.js'
import DeceasedsModel from 'models/deceaseds.js'

import modelTools from 'functions/models.js'
import relationTools from 'functions/relations.js'
import addressTools from 'functions/address.js'
import contactTools from 'functions/contact.js'
import graveTools from 'functions/grave.js'
import deceasedTools from 'functions/deceased.js'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('customers')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	beforeRouteLeave(to, from, next) {
		if (to.path === '/'+this.model.name+'/new') {
			this.model.clearModel()
		}
		next()
	},

	props: {
		IsModal: {
			type: Boolean,
			default: false
		}
	},

	// data ist ein Abbild der aktuell auf der Seite verfügbaren Informationen
	data () {
		return {
			_main_id: 0,

			//_selectedZip: {},
			// selectedZip: { zip: "", city: ""},

			model: CustomersModel,
			graves: GravesModel,
			deceaseds: DeceasedsModel,
			addresses: AddressesModel,
			contacts: ContactsModel,

			// visibleModal: 'addgraves'
			visibleModal: '',

			graveSort: {col: 'id', order: 'asc'},

			addDeceasedMode: 'relation',

			deceasedCols: [
				{ 'name': 'Vorname', 'json': 'firstname', 'type': 'text' },
				{ 'name': 'Nachname', 'json': 'lastname', 'type': 'text' },
				{ 'name': 'Geburtstag', 'json': 'birthday', 'type': 'date' },
				{ 'name': 'Todestag', 'json': 'dyingday', 'type': 'date', 'colCSS': 'hidden-xs' }
			],

			graveCols: [
				{ 'name': 'Name', 'json': 'name', 'type': 'text' },
				{ 'name': 'Fläche', 'json': 'area_name', 'type': 'text' },
				{
					name: 'Kunden',
					json: 'customer_count',
					type: 'int',
					css: {
						default: 'btn btn-danger',
						0: 'btn btn-success'
					}
				},
				{
					name: 'Verstorbene',
					json: 'deceased_count',
					type: 'int',
					css: {
						default: 'btn btn-danger',
						0: 'btn btn-success'
					}
				}
			],
		}
	},

	mounted () {
		$('.responsive-tabs').responsiveTabs({
			accordionOn: ['xs', 'sm'] // xs, sm, md, lg
		})
		console.log("Boom")
	},

	activated () {
		this.model.clearModel()
		this.model.model.id = parseInt(this.$route.params.customer_id)
		if (isNaN(this.model.model.id)) {
			this.model.model.id = 0
		}

		this.$store.dispatch('loadModels', this.model.relations)
		.then(() => {
			this.$store.dispatch('loadModel', 'customers')
			.then(result => {
				var model = this.$store.getters.model('customers', this.model.model.id)
				this.model.copy(model)

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'addresses'})
				.then(data => this.initRelation('addresses', data))

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'contacts'})
				.then(data => this.initRelation('contacts', data))

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'graves'})
				.then(data => this.initRelation('graves', data))

				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'deceaseds'})
				.then(data => this.initRelation('deceaseds', data))
			})
		})
	},

	computed: {
		validModel () {
			const FirstnameOK = typeof this.model.model.firstname === "string" && this.model.model.firstname.trim() !== ""
			const LastnameOK = typeof this.model.model.firstname === "string" && this.model.model.firstname.trim() !== ""

			return FirstnameOK && LastnameOK
		},

		/*selectedZip: {
			get () {
				return this._selectedZip
			},

			set (aEntry) {
				this._selectedZip = aEntry
				console.log(aEntry)
			}
		},*/

  		main_id: {
  			get () {
				return this._main_id
			},

  			set (aID) {
				this._main_id = aID
			}
		},

		pageheader () {
			let model
			let name

			if (this.model.model.id === 0) {
				return 'Neuen Kunden anlegen'
			} else {
				model = this.$store.getters.model('customers', this.model.model.id)
				name = model.firstname + ' ' + model.lastname

				return 'Kunde "' + name.trim() + '" verwalten'
			}
		}
	},

	components: {
		CustomTable,
		CustomModal,
		CustomModalOld,
		CustomInput,
		Datepicker,
		NewDeceased,
		CustomSelect,
		CustomerDeceased,
		CustomSearchInput,
		ModelListSelect,
		AddressContent,
		ContactContent,
		tabs,
		tabGroup,
		tab
	},

	methods: {
		// Tools des Models
		saveModel: modelTools.save,

		// Beziehungen zwischen Models
		initRelation: relationTools.init,
		editRelation: relationTools.edit,
		deleteRelation: relationTools.delete,
		addRelation: relationTools.add,
		saveRelation: relationTools.save,
		confirmDeleteRelation: relationTools.confirmDelete,

		addDeceased () {
			this.$refs.deceasedAddModal.open()
		},

		storeDeceased (aModel) {
			axios.post("/api/customers/" + this.model.model.id + "/deceaseds/", {customer_id: this.model.model.id, deceased_id: aModel.id})
			.then(() => {
				this.$refs.deceasedAddModal.cancel()
			})
		},

		addressModal () {
			this.$refs.addressModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newAddress.model.model.street.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.number.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.zip.trim() === "") {
					return false
				}

				if (this.$refs.newAddress.model.model.city.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('addresses')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addAddress () {
			this.addresses.clear()
			this.addressModal()
		},

		// Adressen speziefische Methoden
		editAddress (aModel) {
			this.addresses.copy(aModel)
			this.addressModal()
		},

		deleteAddress: addressTools.delete,

		// Kontakt speziefische Methoden
		contactModal () {
			this.$refs.contactModal.open( () => {
				// Callback um zzu prüfen ob das Modal geschlossen werden kann
				if (this.$refs.newContact.model.model.value.trim() === "") {
					return false
				}

				return true
			})
			.then(() => {
				this.saveRelation('contacts')
			})
			.catch(() => {
				// Erfolgloses schließen
				console.log("CANCEL")
			})
		},

		addContact () {
			this.contacts.clear()
			this.contactModal()
		},

		// Adressen speziefische Methoden
		editContact (aModel) {
			this.contacts.copy(aModel)
			this.contactModal()
		},

		deleteContact: contactTools.delete,

		// Grab speziefische Methoden
		deleteGrave: graveTools.delete,

		editGrave (aModel) {
			this.graves.copy(aModel)
			this.$refs.graveEditModal.open()
			.then(() => {
				this.saveRelation('graves')
			})
		},

		addGrave () {
			$('.responsive-tabs').responsiveTabs({
				accordionOn: ['xs', 'sm'] // xs, sm, md, lg
			})

			this.$refs.graveModal.open()
		},

		// Verstorbener speziefische Methoden
		deleteDeceased: deceasedTools.delete,

		saveDeceased (aModel) {
			this.saveModel(aModel, true)
			.then(id => {
				axios.post("/api/customers/" + this.model.model.id + "/deceaseds/", {customer_id: this.model.model.id, deceased_id: id})
				.then( () => {
					this.$refs.deceasedAddModal.cancel()
				})
				.catch(() => {
					console.log("O_O")
				})
			})
			.catch(() => {
				console.log("O_____________O")
			})
		},

		saveCustomer (aModel) {
			this.saveModel()
			.then(id => {
				this.model.model.id = id
				this.$router.replace("/customers/" + id)
			})
			.catch(id => {
				this.model.model.id = id
			})
		},

		saveGrave (aModel) {
			this.graves.model.name = aModel.id + ': Dummy'
			this.graves.model.id = 0
			this.saveRelation('graves')
			this.visibleModal = ''
			this.$refs.graveModal.cancel()
		},

		saveAllGraves (aModels) {
			const models = aModels.map(model => {
				return {
					'id': model.id,
					'grave_id': model.id,
					'from':  moment(this.graves.model.from, 'YYYY-MM-DD').toISOString(),
					'until':  moment(this.graves.model.until, 'YYYY-MM-DD').toISOString()
				}
			})

			axios.post('/api/customers/' + this.model.model.id + '/graves/', models)
			.then((response) => {
				this.$store.dispatch('loadRelation', {basis: this.model, relation: 'graves'})
				.then(data => {
					this.initRelation('graves', data)
					this.$store.dispatch('updateModel', 'graves')
				})
				.then(() => {
					this.$refs.graveModal.cancel()
				})
			})
		},

		multiselect (allModels) {
			allModels.forEach(Item => console.log(Item.name))
		}
	}
}
</script>



// WEBPACK FOOTER //
// CustomerEdit.vue?795a881c